import ProcessingPage from 'components/new/ProcessingPage';

const ImportingTransactions: React.FC = () => {
  return (
    <ProcessingPage
      fullHeight
      title="Importing statement transactions"
      subtitle="Please wait while we import your bank account transactions."
    />
  );
};

export default ImportingTransactions;
